<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title>{{title}}</h1>
    <div fxFlex.gt-sm="auto" class="scroll" fxLayout="column" fxLayoutAlign="start stretch">
        <div [innerHTML]="message | safeHTML"></div>
        <mat-selection-list #clist dense [(ngModel)]="Courses">
            <mat-list-option [value]="1">AICE Math 1 AS</mat-list-option>
            <mat-list-option [value]="2">AICE MA&PR&ST 2 AL</mat-list-option>
            <mat-list-option [value]="4">Algebra 1 / Algebra 1 Honors</mat-list-option>
            <mat-list-option [value]="8">Algebra 2 / Algebra 2 Honors</mat-list-option>
            <mat-list-option [value]="16">Geometry / Geometry Honors</mat-list-option>
            <mat-list-option [value]="32">IB PRECALCULUS</mat-list-option>
            <mat-list-option [value]="64">Pre-AICE Math 2 IG</mat-list-option>
            <mat-list-option [value]="128">Pre-AICE Math 3 IG</mat-list-option>
            <mat-list-option [value]="256">PRECALCULUS Honors</mat-list-option>
            <mat-list-option [value]="512">English 4 / English 4 Honors</mat-list-option>
            <mat-list-option [value]="1024">IB MYP Algebra 1</mat-list-option>
        </mat-selection-list>
    </div>
    <div
        class="actionbar"
        fxLayout="row"
        fxLayoutAlign="end center"
        fxLayoutGap="15px"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="start center"
    >
        <button mat-raised-button color="warn" (click)="CancelHandler()"><span [innerHTML]="canceltext | safeHTML"></span></button>
        <button mat-raised-button color="primary" (click)="OkHandler()" [disabled]="!Courses?.length">
            <span
                [innerHTML]="oktext | safeHTML
        "
            ></span>
        </button>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/services/dialogs/eligiblecourses/eligiblecourses.dialogcomponent.html